import * as Action from '../action';

const initialState = {
  showAllMenu: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Action.SET_SHOW_ALL_MENU:
      return { ...state, showAllMenu: action.value };
    default:
      return state;
  }
};
